import React from "react"
import { Container, Row, Col, Card } from "reactstrap"

const ComingSoon = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
            <Col lg={6}>
              <Card className="text-center p-5">
                <h1 className="display-4 mb-4">Coming Soon!</h1>
                <p className="lead">This feature is currently under development.</p>
                <div className="mt-4">
                  <i className="bx bx-time-five bx-lg text-primary"></i>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ComingSoon 